import { useTranslator } from '@gandi/translate';
export const legacySizeNames = ['s', 's+', 'm', 'l', 'xl', 'xxl'];
export const sizeNames = ['essential', 'starter', 'advanced', 'pro', 'business'];
export function getStorageTranslation({
  translator: {
    __
  },
  storage
}) {
  return storage < 1000 ? __('%(storage)s GB storage', {
    storage
  }) : __('%(storage)s TB storage', {
    storage: storage / 1000
  });
}
export function getMemoryTranslation({
  translator: {
    __
  },
  memory
}) {
  return memory < 1024 ? __('%(memory)s MB RAM', {
    memory
  }) : __('%(memory)s GB RAM', {
    memory: memory / 1024
  });
}
export const getSubprocess = (payload, prices) => {
  if (payload.size && prices?.length === 2) return 'resize';
  if (payload.data_disk_additional_size) return 'add_disk';
  return undefined;
};
export const getIsLegacy = payload => legacySizeNames.includes(payload.size);
export const getIsWebhosting = payload => payload.product_name === 'webhosting' || sizeNames.includes(payload.size);
export const getActualSize = payload => {
  if (payload.actualSize) return payload.actualSize;
  if (!getIsWebhosting(payload) || !payload.subProcessDescription) return undefined;
  const sizesInDescription = [...payload.subProcessDescription.matchAll(/ESSENTIAL|STARTER|ADVANCED|PRO|BUSINESS/g)].map(e => e[0]);
  if (sizesInDescription.includes('ESSENTIAL')) return 'essential';
  if (sizesInDescription.includes('STARTER')) return 'starter';
  if (sizesInDescription.includes('ADVANCED')) return 'advanced';
  if (sizesInDescription.includes('PRO')) return 'pro';
  if (sizesInDescription.includes('BUSINESS')) return 'business';
  return undefined;
};
export function getResizeDescription({
  payload,
  payload: {
    size
  },
  translator: {
    __
  }
}) {
  const actualSize = getActualSize(payload);
  if (!actualSize || !size) return undefined;
  return __('Change size from %(actualSize)s to %(newSize)s', {
    actualSize: actualSize.toUpperCase(),
    newSize: `${size}`.toUpperCase()
  });
}
export function useResizeDescription(payload) {
  const translator = useTranslator();
  return getResizeDescription({
    payload,
    translator
  });
}
export function getRenewalPeriod(product) {
  const appliedPrice = (product.prices || []).find(p => !['Domain', 'storage'].includes(p.description) && p.product_type === 'paas');
  return {
    dateStart: appliedPrice?.date_start,
    dateEnd: appliedPrice?.date_end
  };
}
export function getDataDiskAdditionalSize(payload, addedStorage) {
  if (payload.shopping) {
    const {
      additionalStorage
    } = payload.shopping;
    if (additionalStorage != null && Number.isFinite(additionalStorage)) return additionalStorage + addedStorage;
  }
  return payload.data_disk_additional_size || 0;
}
export function getAddedStorage({
  data_disk_additional_size,
  shopping
}) {
  const additionalStorage = shopping?.additionalStorage;
  if (additionalStorage != null && Number.isFinite(additionalStorage) && data_disk_additional_size != null && Number.isFinite(data_disk_additional_size)) return data_disk_additional_size - additionalStorage;
  return undefined;
}
export function getAddDiskDescription({
  payload,
  translator,
  translator: {
    __
  }
}) {
  const storage = getAddedStorage(payload) || payload.added_storage || payload.data_disk_additional_size;
  return storage ? __('Add %(size)s', {
    size: getStorageTranslation({
      translator,
      storage
    })
  }) : undefined;
}